import { render, staticRenderFns } from "./TrainingWidget.vue?vue&type=template&id=9532b4de&"
import script from "./TrainingWidget.vue?vue&type=script&lang=js&"
export * from "./TrainingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports